import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import { withStyles } from '@material-ui/styles';
import { Grid, Typography, TableContainer } from '@material-ui/core';
import AppContext from '../../../../App/AppContext';
import DashboardYtdHeaderRow from './maYtdDashboardHeader';
import DashboardYtdDataRow from './maYtdDashbordDataRows';
import MADashYtdFooterRow from './maYtdDashboardFooter';
const useStyles = makeStyles({
    table: {
        // minWidth: '100%',
        border: '1px dotted lightgrey'
    },
    header: {
        background: '#2a4d90',
        color: 'white',
        padding: '1px 5px',
        fontWeight: 500,
        fontSize: '13px',
        border: '1px solid #ccc'
    },
    body: {
        padding: '1px 5px',
        fontWeight: 500,
        fontSize: '13px',
        border: '1px solid #ccc'
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        border: 'none'
        // border: '1px solid #ccc'
    }
}))(TableCell);

export default function ServiceTableYTD() {
    const { showToast } = useContext(AppContext);

    const {
        state,
        categoryList,
        dataList,
        calculateKIP,
        getBranchData,
        getFrenChiseData,
        screenDetails,
        getOverallAccountCodeData,
        BranchNullEntry,
        FrenchiseNullEntry,
        headerArrayYTD,
        calculateOverallTotal,
        getCalculatedBranchData,
        ByPassCalculationsTotal,
        getCalculatedFranchiseData
    } = useContext(BranchFranchiseCompareContext);

    const UnderLineRow = () => {
        return (
            <TableRow>
                <StyledTableCell style={{ padding: '5px 40px', background: 'white', border: 'none' }} align="center" colSpan={6}>
                    <hr className="sep-2" />
                </StyledTableCell>
                <StyledTableCell
                    style={{
                        padding: '5px 40px',
                        background: 'white',
                        border: 'none',
                        borderRight: '2px solid grey'
                    }}
                    align="center"
                    colSpan={1}
                >
                    <hr className="sep-2" />
                </StyledTableCell>
                <StyledTableCell style={{ padding: '5px 40px', background: 'white', border: 'none' }} align="center" colSpan={6}>
                    <hr className="sep-2" />
                </StyledTableCell>
            </TableRow>
        );
    };

    return (
        <Grid container spacing={2} justifyContent="space-evenly">
            {state.branchNewList.length === 0 ? (
                <Grid item xs={12}>
                    <Typography>Please Select Branch</Typography>
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Grid container spacing={1} justifyContent="flex-start">
                        {state.branchNewList?.map((branchObj, branchIndex = 0) => {
                            let mainHeader = [];
                            mainHeader = headerArrayYTD;

                            return (
                                <>
                                    {state?.franchise?.length > 0 ? (
                                        state?.franchise?.map((fren, index) => {
                                            return (
                                                <Grid item xs={12} sm={12} md={12} xl={6} key={`fernKey${index}`}>
                                                    <TableContainer
                                                        style={{ padding: 5, borderRadius: 5, maxHeight: 'calc(100vh - 263px)' }}
                                                        className="custom-scroll"
                                                    >
                                                        <Table className={'module'} aria-label="simple table" stickyHeader>
                                                            <TableHead>
                                                                {/* Row 1 */}
                                                                <TableRow>
                                                                    <StyledTableCell
                                                                        colSpan={13}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            padding: 0,
                                                                            position: 'sticky',
                                                                            top: -5,
                                                                            zIndex: 3
                                                                        }}
                                                                    >
                                                                        {branchObj.name}
                                                                    </StyledTableCell>
                                                                </TableRow>

                                                                {/* Row 2 */}
                                                                <TableRow>
                                                                    <StyledTableCell
                                                                        colSpan={13}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            padding: 0,
                                                                            position: 'sticky',
                                                                            top: 21, // height of row 1
                                                                            zIndex: 2
                                                                        }}
                                                                    >
                                                                        {fren.name}
                                                                    </StyledTableCell>
                                                                </TableRow>
                                                                <TableRow
                                                                    style={{
                                                                        backgroundColor: screenDetails.bgColor,
                                                                        color: screenDetails.txtColor,
                                                                        border: '1px solid #ccc',
                                                                        fontSize: 10,
                                                                        position: 'sticky',
                                                                        top: 46, // height of row 1 + row 2
                                                                        zIndex: 1
                                                                    }}
                                                                >
                                                                    <StyledTableCell
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: 'none',
                                                                            padding: 0
                                                                        }}
                                                                    ></StyledTableCell>
                                                                    <StyledTableCell
                                                                        colSpan={6}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            padding: 0
                                                                        }}
                                                                    >
                                                                        MTD
                                                                    </StyledTableCell>
                                                                    <StyledTableCell
                                                                        colSpan={6}
                                                                        align="center"
                                                                        style={{
                                                                            backgroundColor: screenDetails.bgColor,
                                                                            color: screenDetails.txtColor,
                                                                            border: '1px solid #ccc',
                                                                            borderLeft: '2px solid grey',
                                                                            padding: 0
                                                                        }}
                                                                    >
                                                                        YTD
                                                                    </StyledTableCell>
                                                                </TableRow>

                                                                {/* Row 3 (main header) */}
                                                                <TableRow>
                                                                    {mainHeader?.map((m, i) => (
                                                                        <StyledTableCell
                                                                            style={{
                                                                                backgroundColor: screenDetails.bgColor,
                                                                                color: screenDetails.txtColor,
                                                                                border: '1px solid #ccc',
                                                                                fontSize: 11,
                                                                                position: 'sticky',
                                                                                top: 71, // height of row 1 + row 2
                                                                                zIndex: 1
                                                                            }}
                                                                            key={i}
                                                                            align={m.align}
                                                                            width={i === 0 ? '700px' : i === 4 ? '50px' : '120px'}
                                                                        >
                                                                            {m.name}
                                                                        </StyledTableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {categoryList?.map((k = {}, i) => {
                                                                    const branchId = branchObj.id;
                                                                    const isCalculated = k.calculated == 1;
                                                                    const isTotalCalculated = k.calculated == 2;
                                                                    let categoryCount = 0;
                                                                    let totalKpi = 0;
                                                                    let totalYTDKpi = 0;
                                                                    let FrenNullEntry = FrenchiseNullEntry(
                                                                        dataList,
                                                                        fren.id,
                                                                        k.categoryId,
                                                                        branchObj.id,
                                                                        k.calculated
                                                                    );
                                                                    let FranchiseList = getFrenChiseData(branchObj.id, k.categoryId, fren.id);
                                                                    const calculationList = getCalculatedFranchiseData(
                                                                        branchObj.id,
                                                                        fren.id,
                                                                        k.calculated || isTotalCalculated,
                                                                        k.calculation,
                                                                        k.categoryId
                                                                    );

                                                                    const rowData = isTotalCalculated
                                                                        ? []
                                                                        : isCalculated
                                                                        ? calculationList.filter((item) => item.catID === k.categoryId)
                                                                        : FranchiseList;

                                                                    const rawTotals = calculateOverallTotal(k.categoryId, branchId, fren.id);
                                                                    const calcTotals = ByPassCalculationsTotal(calculationList, k.categoryId);

                                                                    const totals = {
                                                                        actual:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_actual
                                                                                : rawTotals.Total_actual,
                                                                        budget:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_budget
                                                                                : rawTotals.Total_budget,
                                                                        actualLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_actualLY
                                                                                : rawTotals.Total_actualLY,
                                                                        varLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_varLY
                                                                                : rawTotals.Total_varLY,
                                                                        variance:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_variance
                                                                                : rawTotals.Total_variance,
                                                                        ytdActual:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_ytdActual
                                                                                : rawTotals.Total_ytdActual,
                                                                        ytdActualLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_ytdActualLY
                                                                                : rawTotals.Total_ytdActualLY,
                                                                        ytdBudget:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_ytdBudget
                                                                                : rawTotals.Total_ytdBudget,
                                                                        ytdVarLY:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_ytdVarLY
                                                                                : rawTotals.Total_ytdVarLY,
                                                                        ytdVariance:
                                                                            isCalculated || isTotalCalculated
                                                                                ? calcTotals.calTotal_ytdVariance
                                                                                : rawTotals.Total_ytdVariance
                                                                    };

                                                                    return (
                                                                        <React.Fragment>
                                                                            <DashboardYtdHeaderRow config={k} />

                                                                            <>
                                                                                {rowData.map((data) => {
                                                                                    const kpi = isCalculated
                                                                                        ? calculateKIP(totals.actual, data.actual)
                                                                                        : calculateKIP(rawTotals.Total_actual, data.actual);
                                                                                    const kpiYTD = isCalculated
                                                                                        ? calculateKIP(totals.ytdActual, data.ytdActual)
                                                                                        : calculateKIP(rawTotals.Total_ytdActual, data.ytdActual);

                                                                                    totalKpi += kpi;
                                                                                    totalYTDKpi += kpiYTD;
                                                                                    categoryCount++;

                                                                                    return (
                                                                                        <DashboardYtdDataRow
                                                                                            key={`data-${data.id}-${i}`}
                                                                                            data={data}
                                                                                            kpiValue={kpi}
                                                                                            kpiValueYTD={kpiYTD}
                                                                                            categoryName={k.categoryName}
                                                                                            getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                            showToast={showToast}
                                                                                            branchId={branchObj.id}
                                                                                            frenchise={fren.id}
                                                                                            k={k}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                                {FrenNullEntry.sort((a, b) => a.sequence - b.sequence).map((data) => {
                                                                                    return (
                                                                                        <DashboardYtdDataRow
                                                                                            key={`null-${data.id}-${i}`}
                                                                                            data={data}
                                                                                            isNull={true}
                                                                                            categoryName={k.categoryName}
                                                                                            getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                            showToast={showToast}
                                                                                            branchId={branchObj.id}
                                                                                            frenchise={fren.id}
                                                                                            k={k}
                                                                                        />
                                                                                    );
                                                                                })}
                                                                            </>

                                                                            <MADashYtdFooterRow
                                                                                config={k}
                                                                                categoryCount={categoryCount}
                                                                                totals={{
                                                                                    ...totals,
                                                                                    totalKpi,
                                                                                    totalYTDKpi
                                                                                }}
                                                                            />

                                                                            {index !== categoryList.length - 1 && <UnderLineRow />}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            );
                                        })
                                    ) : (
                                        <Grid item xs={12} sm={12} md={12} xl={6}>
                                            <TableContainer style={{ padding: 5, borderRadius: 5, maxHeight: 'calc(100vh - 263px)' }} className="custom-scroll">
                                                <Table className={'module'} aria-label="simple table" stickyHeader>
                                                    <TableHead>
                                                        {/* Row 1 */}
                                                        <TableRow>
                                                            <StyledTableCell
                                                                colSpan={13}
                                                                align="center"
                                                                style={{
                                                                    backgroundColor: screenDetails.bgColor,
                                                                    color: screenDetails.txtColor,
                                                                    border: '1px solid #ccc',
                                                                    padding: 0,
                                                                    position: 'sticky',
                                                                    top: -5,
                                                                    zIndex: 3
                                                                }}
                                                            >
                                                                {branchObj.name}
                                                            </StyledTableCell>
                                                        </TableRow>

                                                        {/* Row 2 */}

                                                        <TableRow
                                                            style={{
                                                                backgroundColor: screenDetails.bgColor,
                                                                color: screenDetails.txtColor,
                                                                border: '1px solid #ccc',
                                                                fontSize: 10,
                                                                position: 'sticky',
                                                                top: 21, // height of row 1 + row 2
                                                                zIndex: 1
                                                            }}
                                                        >
                                                            <StyledTableCell
                                                                align="center"
                                                                style={{
                                                                    backgroundColor: screenDetails.bgColor,
                                                                    color: screenDetails.txtColor,
                                                                    border: 'none',
                                                                    padding: 0
                                                                }}
                                                            ></StyledTableCell>
                                                            <StyledTableCell
                                                                colSpan={6}
                                                                align="center"
                                                                style={{
                                                                    backgroundColor: screenDetails.bgColor,
                                                                    color: screenDetails.txtColor,
                                                                    border: '1px solid #ccc',
                                                                    padding: 0
                                                                }}
                                                            >
                                                                MTD
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                colSpan={6}
                                                                align="center"
                                                                style={{
                                                                    backgroundColor: screenDetails.bgColor,
                                                                    color: screenDetails.txtColor,
                                                                    border: '1px solid #ccc',
                                                                    borderLeft: '2px solid grey',
                                                                    padding: 0
                                                                }}
                                                            >
                                                                YTD
                                                            </StyledTableCell>
                                                        </TableRow>

                                                        {/* Row 3 (main header) */}
                                                        <TableRow>
                                                            {mainHeader?.map((m, i) => (
                                                                <StyledTableCell
                                                                    style={{
                                                                        backgroundColor: screenDetails.bgColor,
                                                                        color: screenDetails.txtColor,
                                                                        border: '1px solid #ccc',
                                                                        fontSize: 10,
                                                                        position: 'sticky',
                                                                        top: 46, // height of row 1 + row 2
                                                                        zIndex: 1
                                                                    }}
                                                                    key={i}
                                                                    align={m.align}
                                                                    width={i === 0 ? '700px' : i === 4 ? '50px' : '120px'}
                                                                >
                                                                    {m.name}
                                                                </StyledTableCell>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {categoryList?.map((category = {}, index) => {
                                                            const branchId = branchObj.id;
                                                            const branchData = getBranchData(branchId);
                                                            const isCalculated = category.calculated == 1;
                                                            const isTotalCalculated = category.calculated == 2;

                                                            // Raw totals
                                                            const rawTotals = calculateOverallTotal(category.categoryId, branchId);
                                                            // Calculated totals
                                                            const calcList = getCalculatedBranchData(
                                                                branchId,
                                                                isCalculated || isTotalCalculated,
                                                                category.calculation,
                                                                category.categoryId
                                                            );
                                                            const calcTotals = ByPassCalculationsTotal(calcList, category.categoryId);

                                                            const totals = {
                                                                actual: isCalculated || isTotalCalculated ? calcTotals.calTotal_actual : rawTotals.Total_actual,
                                                                budget: isCalculated || isTotalCalculated ? calcTotals.calTotal_budget : rawTotals.Total_budget,
                                                                actualLY:
                                                                    isCalculated || isTotalCalculated ? calcTotals.calTotal_actualLY : rawTotals.Total_actualLY,
                                                                varLY: isCalculated || isTotalCalculated ? calcTotals.calTotal_varLY : rawTotals.Total_varLY,
                                                                variance:
                                                                    isCalculated || isTotalCalculated ? calcTotals.calTotal_variance : rawTotals.Total_variance,
                                                                ytdActual:
                                                                    isCalculated || isTotalCalculated
                                                                        ? calcTotals.calTotal_ytdActual
                                                                        : rawTotals.Total_ytdActual,
                                                                ytdActualLY:
                                                                    isCalculated || isTotalCalculated
                                                                        ? calcTotals.calTotal_ytdActualLY
                                                                        : rawTotals.Total_ytdActualLY,
                                                                ytdBudget:
                                                                    isCalculated || isTotalCalculated
                                                                        ? calcTotals.calTotal_ytdBudget
                                                                        : rawTotals.Total_ytdBudget,
                                                                ytdVarLY:
                                                                    isCalculated || isTotalCalculated ? calcTotals.calTotal_ytdVarLY : rawTotals.Total_ytdVarLY,
                                                                ytdVariance:
                                                                    isCalculated || isTotalCalculated
                                                                        ? calcTotals.calTotal_ytdVariance
                                                                        : rawTotals.Total_ytdVariance
                                                            };

                                                            const filteredData = (isTotalCalculated ? [] : isCalculated ? calcList : branchData)
                                                                .filter((item) =>
                                                                    isCalculated
                                                                        ? item.catID === category.categoryId
                                                                        : item.maDashboardCategoryId === category.categoryId
                                                                )
                                                                .sort((a, b) => a.sequence - b.sequence);

                                                            const nullBranchData = BranchNullEntry(
                                                                branchData,
                                                                dataList,
                                                                category.categoryId,
                                                                branchId,
                                                                isCalculated
                                                            ).sort((a, b) => a.sequence - b.sequence);

                                                            let totalKpi = 0;
                                                            let totalYTDKpi = 0;

                                                            return (
                                                                <React.Fragment key={`cat-${category.categoryId}-${index}`}>
                                                                    <DashboardYtdHeaderRow config={category} />

                                                                    {filteredData.map((data, i) => {
                                                                        const kpi = isCalculated
                                                                            ? calculateKIP(totals.actual, data.actual)
                                                                            : calculateKIP(rawTotals.Total_actual, data.actual);
                                                                        const kpiYTD = isCalculated
                                                                            ? calculateKIP(totals.ytdActual, data.ytdActual)
                                                                            : calculateKIP(rawTotals.Total_ytdActual, data.ytdActual);

                                                                        totalKpi += kpi;
                                                                        totalYTDKpi += kpiYTD;

                                                                        return (
                                                                            <DashboardYtdDataRow
                                                                                key={`data-${data.id}-${i}`}
                                                                                data={data}
                                                                                kpiValue={kpi}
                                                                                kpiValueYTD={kpiYTD}
                                                                                categoryName={category.categoryName}
                                                                                getOverallAccountCodeData={getOverallAccountCodeData}
                                                                                showToast={showToast}
                                                                                branchId={branchObj.id}
                                                                                k={category}
                                                                            />
                                                                        );
                                                                    })}

                                                                    {nullBranchData.map((data, i) => (
                                                                        <DashboardYtdDataRow
                                                                            key={`null-${data.id}-${i}`}
                                                                            data={data}
                                                                            isNull={true}
                                                                            categoryName={category.categoryName}
                                                                            getOverallAccountCodeData={getOverallAccountCodeData}
                                                                            showToast={showToast}
                                                                            branchId={branchObj.id}
                                                                            k={category}
                                                                        />
                                                                    ))}

                                                                    <MADashYtdFooterRow
                                                                        config={category}
                                                                        categoryCount={filteredData.length}
                                                                        totals={{
                                                                            ...totals,
                                                                            totalKpi,
                                                                            totalYTDKpi
                                                                        }}
                                                                    />

                                                                    {index !== categoryList.length - 1 && <UnderLineRow />}
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )}
                                </>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
}
